import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useGetFramework } from '../../hooks';
import { CookieConsent } from '../cookie-consent';
import * as styles from './welcome-screen.module.scss';

export const WelcomeScreen = () => {
  const userAgentString = navigator.userAgent;

  const [isSafari, setIsSafari] = useState<boolean>();
  const [isLocalOrDev, setIsLocalOrDev] = useState<boolean>();

  useEffect(() => {
    setIsLocalOrDev(
      window && window.location.href.indexOf('.bmisverige.se') === -1,
    );

    if (
      userAgentString.indexOf('Chrome') === -1 &&
      userAgentString.indexOf('Safari') > -1
    ) {
      setIsSafari(true);
    }
  }, [userAgentString]);

  const framework = useGetFramework();
  const { loginWithRedirect } = useAuth0();
  const login = async () => {
    if (loginWithRedirect) {
      await loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      });
    }
  };
  return (
    <>
      <Helmet>
        <title>{framework.welcomeScreenTitle}</title>
        {isLocalOrDev && <meta name="robots" content="noindex,nofollow"></meta>}
      </Helmet>
      <Box className={styles.welcomeScreen} data-testid="welcome-screen">
        <div>
          <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.logo}
            viewBox="0 0 81 31"
          >
            <g>
              <path
                d="M81 10.192h-2.225V20.88H81V10.192ZM38.506 12.822h-2.225v8.058h2.225v-8.057ZM38.506 10.206h-2.225v2.034h2.225v-2.034ZM53.636 18.892c-.414 0-.818-.12-1.163-.345a2.055 2.055 0 0 1-.77-.917 2 2 0 0 1-.12-1.181c.081-.397.28-.761.574-1.047.292-.286.665-.48 1.071-.56a2.139 2.139 0 0 1 1.21.117c.382.155.708.417.938.753a2.01 2.01 0 0 1-.26 2.581c-.194.19-.425.34-.679.443a2.136 2.136 0 0 1-.8.156Zm0-6.231a4.36 4.36 0 0 0-2.381.706 4.21 4.21 0 0 0-1.579 1.879 4.098 4.098 0 0 0-.243 2.419 4.158 4.158 0 0 0 1.173 2.144 4.32 4.32 0 0 0 2.194 1.146 4.382 4.382 0 0 0 2.477-.239 4.266 4.266 0 0 0 1.923-1.542 4.104 4.104 0 0 0 .396-3.929 4.182 4.182 0 0 0-.929-1.358 4.295 4.295 0 0 0-1.39-.908 4.374 4.374 0 0 0-1.64-.318ZM46.047 17.18a2.034 2.034 0 0 1-.772 1.272 2.125 2.125 0 0 1-2.814-.21 2.017 2.017 0 0 1-.565-1.371 2.015 2.015 0 0 1 .53-1.385 2.126 2.126 0 0 1 2.807-.278c.42.304.706.75.805 1.252h2.213a4.158 4.158 0 0 0-1.46-2.778 4.353 4.353 0 0 0-3.021-1.02 4.333 4.333 0 0 0-2.905 1.305 4.138 4.138 0 0 0-1.173 2.905 4.14 4.14 0 0 0 1.21 2.89 4.336 4.336 0 0 0 2.92 1.27 4.35 4.35 0 0 0 3.01-1.055 4.155 4.155 0 0 0 1.424-2.796h-2.209ZM77.423 16.824a4.119 4.119 0 0 0-.728-2.324 4.267 4.267 0 0 0-1.925-1.537 4.38 4.38 0 0 0-2.476-.234 4.318 4.318 0 0 0-2.192 1.149 4.157 4.157 0 0 0-1.17 2.144 4.097 4.097 0 0 0 .246 2.418 4.21 4.21 0 0 0 1.58 1.877 4.36 4.36 0 0 0 2.38.704 4.22 4.22 0 0 0 1.589-.316V18.15a2.092 2.092 0 0 1-1.24.68 2.122 2.122 0 0 1-1.396-.257 2.044 2.044 0 0 1-.903-1.073 1.988 1.988 0 0 1 .014-1.388c.17-.447.498-.82.922-1.056a2.123 2.123 0 0 1 1.402-.23c.48.086.914.334 1.226.702.312.367.481.83.479 1.307v3.633l.005-.002v.415h2.19v-4.057h-.003ZM63.33 12.647c-1.135 0-2.223.44-3.026 1.223a4.138 4.138 0 0 0-1.26 2.953v6.97h2.19v-6.956h.005v-.003a2.037 2.037 0 0 1 .48-1.334c.317-.376.758-.63 1.247-.72.49-.089.995-.006 1.429.233.433.239.766.62.94 1.075.175.455.18.956.013 1.415a2.078 2.078 0 0 1-.921 1.09 2.158 2.158 0 0 1-1.424.257 2.128 2.128 0 0 1-1.26-.698v2.555a4.222 4.222 0 0 0 1.587.315 4.339 4.339 0 0 0 3.031-1.226 4.14 4.14 0 0 0 1.255-2.961 4.14 4.14 0 0 0-1.255-2.961 4.339 4.339 0 0 0-3.031-1.227ZM31.734 0H0v31h31.734V0Z"
                fill="#009FE3"
              />
              <path
                d="m19.73 10.794-1.376 5.536h-.027l-1.378-5.536h-4.222v6.287a2.236 2.236 0 0 0-.49-1.302 2.323 2.323 0 0 0-1.173-.78c.364-.155.672-.415.884-.744.212-.329.318-.713.303-1.101 0-.963-.539-2.36-3.076-2.36H3.901v9.411h5.465c1.625 0 3.225-.892 3.363-2.617v2.617h2.806V14.17h.027l1.672 6.036h2.213l1.673-6.036h.026v6.036h2.807v-9.41H19.73ZM6.867 13.035h1.566c.607 0 1.011.173 1.011.647 0 .606-.39.777-1.011.777H6.868v-1.424Zm1.74 4.93h-1.74v-1.753H8.73c.702 0 1.039.303 1.039.856 0 .725-.54.895-1.16.895M27.833 10.795h-2.968v9.41h2.968v-9.41Z"
                fill="#fff"
              />
            </g>
          </svg>
          <Box
            className={styles.welcomeScreenMessage}
            sx={(theme) => ({
              boxShadow: theme.shadows[5],
            })}
          >
            <Typography component="h1" variant="h3">
              {framework.welcomeScreenTitle}
            </Typography>
            <Box component="div">
              <p>{framework.welcomeScreenBody}</p>
              {
                //TODO: BEB-220 - we need a "Safari Help" text on ContentfulFramework
                isSafari && (
                  <p>
                    <i>{framework.thirdPartyCookiesMessage}</i>
                  </p>
                )
              }
              <Button variant="contained" color="primary" onClick={login}>
                {framework.welcomeScreenLoginButton}
              </Button>
            </Box>
          </Box>
        </div>
      </Box>
      <CookieConsent />
    </>
  );
};
